export const ATTACHMENTS_UPLOAD_COMMAND_PATH = ["attachments", "upload"] as const;

export const BESPOKE_COMMAND_PATHS = [
  ATTACHMENTS_UPLOAD_COMMAND_PATH,
] as const;
